import { FolderPlus, Map as MapIcon } from "lucide-react";
import type { ReactNode } from "react";

import { EmptyState } from "../components/EmptyState";
import { Button } from "../components/ui";
import { VIEW_META } from "../components/viewMeta";
import { t } from "../i18n/i18n";
import { type ViewKey, useUi } from "../state/ui";

/** États vides des vues plein cadre qui ont besoin d'un dossier (R13 : même présentation dans toutes les vues),
 *  toujours rendus sous le `ViewHeader` de la vue : icône de la vue, titre, texte propre à la vue (`children`) et
 *  une seule action.
 *
 *  - `none` : aucun dossier ouvert — « Créer le dossier » (Données initiales, nom du dossier désigné) ;
 *  - `incomplete` : dossier sans carte, niveau ou ordre de bataille — « Compléter les Données initiales ». */
export function DossierEmptyState({
  view,
  kind,
  children,
}: {
  view: ViewKey;
  kind: "none" | "incomplete";
  children: ReactNode;
}) {
  const setView = useUi((s) => s.setView);
  const requestSave = useUi((s) => s.requestSave);
  return kind === "none" ? (
    <EmptyState
      icon={VIEW_META[view].icon}
      title={t("Aucun dossier ouvert")}
      action={
        <Button onClick={() => requestSave(true)}>
          <FolderPlus size={14} /> {t("Créer le dossier")}
        </Button>
      }
    >
      {children}
    </EmptyState>
  ) : (
    <EmptyState
      icon={VIEW_META[view].icon}
      title={t("Dossier incomplet")}
      action={
        <Button onClick={() => setView("mission")}>
          <MapIcon size={14} /> {t("Compléter les Données initiales")}
        </Button>
      }
    >
      {children}
    </EmptyState>
  );
}
